import { useEffect } from 'react'
import { compose, hoc, useStore } from '@'
import { SetFormValues, useForm, useFormLoading } from '@form'
import GetHotelCoverage from '../../actions/GetHotelCoverage'
import { $hotelCoverageQuery } from '../../stores'

const $fieldProps = {
    hotel_id: { rules: [{ required: true, whitespace: true, message: 'Please enter a hotel_id' }] }
}

const container = compose(
    hoc(props => {
        const [query] = useStore([$hotelCoverageQuery])

        const [$props, $form] = useForm(() => {
            const onSubmit = async values => {
                await GetHotelCoverage({ hotel_id: values.hotel_id })
            }

            return {
                name: 'HotelCoverageSearch',
                onSubmit
            }
        }, [])

        const $loading = useFormLoading($form.name)

        const hotelId = query && query.hotel_id

        // A deep link or a hotel just created also lands in the input.
        useEffect(() => {
            if (hotelId) {
                SetFormValues($form.name, { hotel_id: hotelId })
            }
        }, [$form.name, hotelId])

        return {
            $props,
            $loading,
            $fieldProps,
            ...props
        }
    })
)

export default container
